export const BuildQueueTypes = {
	SETTLEMENT: 500,
	STATION: 700,
};

export const UnitPositionTypes = {
	SPACE: 1, // exact x,y position
	ORBIT: 5, // positioned above a hex on the planet
	UNIT: 9, // bound to other unit like another ship or space station
};

export const EntityTypes = {
	SUN: 0,
	PLANET: 1,
	UNIT: 2,
};

export const SunRadius = {
	BLUE: 40,
	WHITE: 35,
	YELLOW: 25,
	ORANGE: 20,
	RED: 15,
	MAGENTA: 15,
	BROWN: 10,
	BLACK: 8,
};

/**
 * complete and canceled are no longer used because those items get deleted to save space
 */
export const BuildQueueStatus = {
	PENDING: 50,
	CANCELED: 80,
	ERROR: 90,
	COMPLETE: 99,
};
